export const Undefined = 'undefined'
export const Number = 'number'
